import { component } from 'picoapp';
import Swiper from 'swiper';
import ProductItem from '../../js/lib/product-item';

export default component(async (node) => {
  /**
   * Data + elements
   */
  const output = node.querySelector('.js-output');
  const sliderElement = node.querySelector('.js-slider');

  /**
   * Functions
   */
  const getProducts = () => new Promise((resolve) => {
    const handles = localStorage.getItem('viewedProducts')?.split(',') || [];

    if (handles.length) {
      const fetches = handles.map((handle, index) => fetch(`/products/${handle}.json`).then((response) => {
        if (response.status === 200) {
          return response.json();
        }
        // If product has been removed from shop, remove it from localStorage as well
        handles.splice(index, 1);
        localStorage.setItem('viewedProducts', handles);
        return null;
      }).then((data) => data?.product || null));

      Promise.all(fetches).then((data) => {
        // Only return actual data items (i.e. ones that are !== null)
        resolve(data.filter((item) => item));
      });
    } else {
      resolve(handles);
    }
  });

  const getMarkup = (products) => products.map((product) => `<li class="product-slider__item swiper-slide">
      ${ProductItem(product)}
    </li>`).join('');

  const init = async () => {
    const products = await getProducts();

    if (products.length) {
      output.innerHTML = getMarkup(products);

      (() => new Swiper(sliderElement, {
        slidesPerView: 'auto',
        grabCursor: true,
      }))();
    } else {
      node.remove();
    }
  };

  /**
   * Init
   */
  init();
});
